module.exports = __webpack_public_path__ + "media/costa_rica/gateway-unimart-header-3db75ab6.png";